export const legacyOauthApps = [/* apps that dan excluded - should be checked and take action to integrate into new installer: */
/* https://wix.atlassian.net/browse/DCC-2331 */
'eb377299-86b4-4a86-a1b5-774a2d1d374b',
// Wix SiteMembers App
'34218813-5942-493a-af68-be90c83b447a',
// Wix add-on for Adobe Express
'f4ef9627-612a-4b63-b8bd-edb7831dcc92',
// Modalyst - Dropshipping
'2b1943e2-3fc2-47bc-be56-3d402e5966d7',
// Shippo
'4df11237-3aff-4fc2-970d-70c7bfc3ccd3',
// SE Ranking
'4cc2c19f-03da-499c-aaaf-33632a02ba58',
// Wincher

/* apps that were excluded because of the RO of new installer: */
/* https://docs.google.com/document/d/1X5u9cPFlPURQLEqf7oPgr_SHBy1cRSjLJ7s2snOE4Fg */
'847183c6-2de1-48ac-8b65-d6d5ba4b7e36',
// IDMC
'0bdf0417-48da-408d-9e68-fc32ebdb2eb2',
// Constant Contact
'ed02abe7-222c-44f6-ae68-8901c9bd5f7e',
// HubSpot by SyncSmart
'adfff264-26e4-41ff-b5f0-b5320c145f08' // Shipreadygo
];
//# sourceMappingURL=legacyOauthApps.js.map